const Medium = (props: SocialIconProps) => {
  const { className } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" className={className}>
      <rect
        width={62}
        height={62}
        x={1}
        y={1}
        className="fill-surface-secondary stroke-skin-stroke"
        strokeWidth={2}
        rx={31}
      />
      <path
        className="fill-skin-primary"
        d="M42.08 24.74 44 22.9v-.4h-6.63l-4.73 11.82-5.38-11.82H20.3v.4l2.24 2.7c.22.2.33.5.3.8v10.63a1.21 1.21 0 0 1-.32 1.05L20 41.16v.4h7.14v-.41l-2.52-3.06a1.25 1.25 0 0 1-.34-1.06v-9.2l6.27 13.73h.73l5.4-13.72v10.93c0 .29 0 .35-.2.54l-1.94 1.88v.4h9.42v-.4l-1.88-1.84a.56.56 0 0 1-.2-.54V25.28a.56.56 0 0 1 .2-.53z"
      />
    </svg>
  );
};

export default Medium;
